import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.REPORTS,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ReportContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'report', reducer: reducer.default })

    cb(null, module.default)
  }
})
